// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_NbwRU","links":"index_links_V-Gkx","divider":"index_divider_WpEkO","span":"index_span_vzAx-"};